import {
  NodeModel,
  PortModelAlignment,
  DefaultPortModel
} from '@projectstorm/react-diagrams'
import { appArchitecturePortOut, nodeType } from './index'

export class ApplicationArchitectureNodeModel extends NodeModel {
  public constructor() {
    super({
      type: nodeType,
      locked: true
    })

    // setup ports
    this.addPort(
      new DefaultPortModel({
        in: false,
        name: appArchitecturePortOut,
        alignment: PortModelAlignment.RIGHT
      })
    )
  }

  public serialize() {
    return {
      ...super.serialize()
    }
  }

  public deserialize(event): void {
    super.deserialize(event)
  }
}
